import React from "react";
import "./ResourceModal.scss";
import i18n from "i18n/config";

interface ResourceModalContent {
  image?: string;
  title?: string;
  title_en?: string;
  title_fr?: string;
  description?: string;
  description_en?: string;
  description_fr?: string;
}

interface ResourceModalProps {
  modalContent?: ResourceModalContent | null;
  onClose?: () => void;
}

const getLocalizedText = (
  content: ResourceModalContent | null | undefined,
  key: "title" | "description",
) => {
  if (!content) return "";

  const localizedKey = i18n.language === "fr" ? `${key}_fr` : `${key}_en`;
  return (
    content[localizedKey as keyof ResourceModalContent] ||
    content[key as keyof ResourceModalContent] ||
    ""
  );
};

const ResourceModal: React.FC<ResourceModalProps> = ({
  modalContent,
  onClose,
}) => {
  const title = getLocalizedText(modalContent, "title");
  const description = getLocalizedText(modalContent, "description");
  const image = modalContent?.image?.trim() || "";

  return (
    <div className="resource-modal">
      <div className="resource-modal__frame">
        {onClose && (
          <button
            className="resource-modal__close"
            onClick={onClose}
            aria-label="Close resource"
          >
            ×
          </button>
        )}

        <div className="resource-modal__content">
          <div
            className={`resource-modal__body ${
              image ? "" : "resource-modal__body--no-image"
            }`}
          >
            {image && (
              <div className="resource-modal__image-container">
                <img
                  src={image}
                  alt={title || "Resource"}
                  className="resource-modal__image"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="320" height="400"%3E%3Crect fill="%23e0e0e0" width="320" height="400"/%3E%3Ctext fill="%239a9a9a" font-family="Arial" font-size="16" x="50%25" y="50%25" text-anchor="middle" dominant-baseline="middle"%3EImage Coming Soon%3C/text%3E%3C/svg%3E';
                  }}
                />
              </div>
            )}

            <div className="resource-modal__info">
              {title && <h2 className="resource-modal__title">{title}</h2>}
              <p className="resource-modal__description">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceModal;
